import { render, staticRenderFns } from "./AgeTechServiceWrite.vue?vue&type=template&id=75ca7d9c&scoped=true"
import script from "./AgeTechServiceWrite.vue?vue&type=script&lang=js"
export * from "./AgeTechServiceWrite.vue?vue&type=script&lang=js"
import style0 from "./AgeTechServiceWrite.vue?vue&type=style&index=0&id=75ca7d9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca7d9c",
  null
  
)

export default component.exports